const watchHeaderScroll = (e) => {
    const scrollTop = typeof window.scrollY === 'undefined' ? window.pageYOffset : window.scrollY
    if(scrollTop > 70 && !menuContainer.classList.contains('scrolled')){
      menuContainer.classList.add('scrolled');
    } else if(scrollTop < 70 && menuContainer.classList.contains('scrolled')){
      menuContainer.classList.remove('scrolled');
    }
  }

  const menuContainer = document.querySelector('.mcl-header-menu');
  const languageMenu = document.querySelector('.mcl-languages');
  if(menuContainer){
    /**
     * hamburger Menu Toogle
     */
    const mobileTrigger = menuContainer.querySelector('.mobile-trigger button');
    const menu = menuContainer.querySelector('.mcl-menu-elements-container > ul');
    mobileTrigger.addEventListener('click', (event) => {
      mobileTrigger.classList.toggle('is-active');
      menu.classList.toggle('mobile-open');
      languageMenu.classList.toggle('open');
    });

    /**
     * Scroll behaviour
     */
    window.addEventListener('scroll', watchHeaderScroll);
    window.addEventListener('DOMContentLoaded', watchHeaderScroll);
  }



// WEBPACK FOOTER //
// ./src/components/templates/header/header.js